export enum LocalStorageKey {
  MINIFIED_CATEGORIES = "MINIFIED_CATEGORIES",
  NOT_MINIFIED_CATEGORIES = "NOT_MINIFIED_CATEGORIES",
  NIGHT_MODE = "NIGHT_MODE",
  PICTURE_BACKGROUND = "PICTURE_BACKGROUND",
  THEME = "THEME",
  SOUND_ACTIVE = "SOUND_ACTIVE",
  TOKEN = "TOKEN",
  APP_VERSION = "APP_VERSION",
}
